import { useObservableAxios } from '../useAxios'
import { ReportType } from '../../../Pages/Reports'
import { useCallback, useRef } from 'react'

type GenerateReportHandlerProps = {
  reportName: string
  reportLabel: string
  startDate: string
  endDate: string
}

const useFetchTaxForms = () => {
  const [reportsAxios, reportsStatus, reportsError, reportsResponse] =
      useObservableAxios<{ reports: ReportType[] }>(),
    // Unfortunately useAxios is not stable across renders, so we need to store it in a ref
    // to keep it stable in a useCallback dependency array
    reportsAxiosRef = useRef(reportsAxios)

  const [generateAxios, generateStatus, generateError] =
      useObservableAxios<unknown>(),
    generateAxiosRef = useRef(generateAxios)

  const generateReport = (body: GenerateReportHandlerProps) =>
    generateAxiosRef.current({ url: '/reports', method: 'POST', data: body })

  // fetchReports will be used in a useEffect, so it needs to be wrapped in useCallback
  const fetchReports = useCallback(
    () => reportsAxiosRef.current({ url: '/reports' }),
    [reportsAxiosRef]
  )

  return [
    [reportsStatus, generateStatus],
    [reportsError, generateError],
    generateReport,
    fetchReports,
    reportsResponse?.reports?.filter(
      (report) => report.reportName === 'GainLossReport'
    ),
  ] as const
}

export default useFetchTaxForms
